// extracted by mini-css-extract-plugin
export var copiedText = "sidebar-module--copiedText--30e9a";
export var icon = "sidebar-module--icon--edeff";
export var shareLink = "sidebar-module--shareLink--be39b";
export var sidebar = "sidebar-module--sidebar--7068a";
export var sidebarStickyChildren = "sidebar-module--sidebarStickyChildren--40ec6";
export var socialIcons = "sidebar-module--socialIcons--608c5";
export var tableOfContents = "sidebar-module--tableOfContents--3b813";